<template>
  <div class="container">

    <el-dialog
            title="打印设置"
            :visible.sync="dialogVisible"
            center
            width="40%"
            @close="dialogClosed">
        <el-form :model="addform" label-position="right" :rules="addrules" ref="refaddForm" label-width="130px" style="width: 90%;">
            <el-form-item label="箱标份数" prop="boxNumber">
                <el-input v-model.trim="addform.boxNumber" type="number" title='' oninput="if(value.length>3)value=value.slice(0,3)" autocomplete="off" maxlength="20" clearable></el-input>
            </el-form-item>
            <el-form-item v-if='labelType === 2 || labelType === 9' label="盘标数量" prop="sBoxNumber">
                <el-input v-model.trim="addform.sBoxNumber" type="number" title='' oninput="if(value.length>3)value=value.slice(0,3)" autocomplete="off" maxlength="20" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item v-if='labelType === 3 || labelType === 12' label="强力批号" prop="trNo">
                <el-input v-model.trim="addform.trNo" autocomplete="off" maxlength="20" clearable></el-input>
            </el-form-item> -->
        </el-form>
        <span slot="footer">
            <el-button class="cancelButton" size="small" @click="dialogVisible = false">取消</el-button>
            <el-button
                    type="primary"
                    size="small"
                    @click="saveForm()"
                    :loading="loadingForm">
                保存
            </el-button>
        </span>
    </el-dialog>

    <div class="topContainer">
      <el-form :model="form" style="width: 80%;" ref="refForm" :rules="rules" label-width="180px">
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.deliveryInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.productOrderNo') + ':'" prop="productOrderNo">
              <el-input
                v-model.trim="form.productOrderNo"
                disabled
                name="productOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.orderTime') + ':'" prop="orderDate">
              <el-input
                v-model.trim="form.orderDate"
                disabled
                name="orderDate"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expectedDeliveryNumber') + ':'" prop="expectCount">
              <el-input
                v-model.trim.number="form.expectCount"
                disabled
                type="tel"
                autocomplete="on"
                clearable
                size="small"
                maxlength="10"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.customerInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
              <el-select
                v-model="form.customerId"
                disabled
                clearable
                filterable
                style="width: 100%;"
                size="small"
                @change="changeCustomer">
                <el-option
                  v-for="item in customersList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.contact') + ':'" prop="contact">
              <el-input
                v-model.trim="form.contact"
                disabled
                name="contact"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="16">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
              <el-input
                v-model.trim="form.contactPhone"
                disabled
                name="contactPhone"
                type="tel"
                autocomplete="on"
                clearable
                size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
              <el-input
                v-model.trim="form.contactAddr"
                disabled
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="20">
            <el-form-item :label="$t('common.comment') + ':'">
              <el-input
                v-model="form.comment"
                disabled
                name="comment"
                type="textarea"
                autocomplete="on"
                clearable
                size="small"
                maxlength="200"
                show-word-limit
                rows="4">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.expressInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expressageType')" prop="expressageType">
              <el-select
                v-model="form.expressageType"
                disabled
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key) in expressageTypes"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.expressage')" prop="expressage">
              <el-select
                v-model="form.expressage"
                disabled
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key)  in expressages"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">订单信息</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item label="视芯订单" prop="processingOrderNo">
              <el-input
                v-model.trim="form.processingOrderNo"
                disabled
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="客户订单" prop="purchaseOrderNo">
              <el-input
                v-model.trim="form.purchaseOrderNo"
                disabled
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item label="物料编号" prop="customPartNo">
              <el-input
                v-model.trim="form.customPartNo"
                disabled
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
		<el-row>
		  <el-col :span="24">
		    <el-table
		      ref="table"
		      stripe border
		      size="mini"
		      :data="form.prodInfos"
		      :cell-style="{textAlign: 'center', padding: '3px 0', fontSize: '12px'}"
		      :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133'}">
		      <el-table-column width="50">
		        <template slot-scope="scope">
		          {{scope.$index + 1}}
		        </template>
		      </el-table-column>
		      <el-table-column
		        :label="$t('common.productName')"
		        width="200">
		        <template slot-scope="scope">
		          <el-form-item
		            label-width="0"
		            :prop="'prodInfos.' + scope.$index + '.prodInfo'"
		            :rules="{
		              required: true,
		              trigger: 'blur',
		              validator: (rule, value, callback) => checkProductId(rule, value, callback, scope.$index),
		            }">
		            <el-select
		              v-model="scope.row.prodInfo"
                  disabled
		              clearable
		              filterable
		              style="width: 100%;"
		              size="small">
		              <el-option
		                v-for="item in productsList"
		                :key="item.id"
		                :label="item.productName + ' / ' + item.chipName"
		                :value="item.productName + '/' + item.chipName">
		              </el-option>
		            </el-select>
		          </el-form-item>
		        </template>
		      </el-table-column>

		      <el-table-column
		        prop="count"
		        :label="$t('common.count')">
		        <template slot-scope="scope">
		          <el-form-item
		            label-width="0"
		            :prop="'prodInfos.' + scope.$index + '.count'"
		            :rules="{
		              required: true,
		              trigger: 'blur',
		              validator: (rule, value, callback) => checkCount(rule, value, callback, scope.$index),
		            }">
		            <el-input
		              v-model.trim.number="scope.row.count"
		              name="count"
                  disabled
		              type="tel"
		              autocomplete="on"
		              clearable
		              maxlength="10"
		              size="small"
		            />
		          </el-form-item>
		        </template>
		      </el-table-column>
		      <el-table-column width="150" :label="$t('common.operate')">
		        <template slot-scope="scope">
		          <el-button
		            type="text"
                disabled
		            icon="el-icon-delete"
		            @click="deleteProductDetails(scope.$index, scope.row)">
		          </el-button>
		        </template>
		      </el-table-column>
		    </el-table>
		  </el-col>
		</el-row>
		<el-form-item label-width="0" style="margin: 10px 0">
		  <el-button
		    class="orange-button"
		    icon="el-icon-plus"
        disabled
		    @click="addClick"
		    circle>
		  </el-button>
		</el-form-item>>

    <el-form-item label-width="0">
      <h4 style="color: #169BD5;">{{$t('deliveryGoods.associatedBoxes')}}</h4>
    </el-form-item>
      </el-form>
      <div class="target-container">
        <el-table
          ref="table"
          border
          :data="prodStores"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          :span-method="objectSpanMethod">
          <el-table-column prop="incoOrderNo" :label="$t('common.orderNo')">
          </el-table-column>
          <el-table-column prop="subNo" :label="$t('common.subNo')">
          </el-table-column>
          <el-table-column prop="boxNo" :label="$t('common.boxNo')"/>
          <el-table-column prop="binLevel" :label="$t('common.binLevel')"/>
          <el-table-column :label="$t('common.productName')" width="200">
            <template slot-scope="scope">
              {{productNameVal(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column prop="lotNo" :label="$t('common.lotNo')"/>
          <el-table-column :label="$t('common.processType')">
            <template slot-scope="scope">
              {{processTypeVal(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column prop="allCount" :label="$t('common.count')"/>
          <el-table-column :label="$t('common.passCount')">
            <template slot-scope="scope">
              {{scope.row.binLevel !== 8 ? scope.row.count : 0}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.failCount')">
            <template slot-scope="scope">
              {{scope.row.binLevel === 8 ? scope.row.count : 0}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button @click="prevStep" size="small" class="prev-button">
          {{$t('common.prevStep')}}
        </el-button>
        <el-button @click="exportXlsx" size="small" class="sure-button">
          {{$t('deliveryGoods.saveXLSX')}}
        </el-button>
        <el-button @click="factoryLabel" size="small" type="primary">
          三方标签
        </el-button>
        <el-button @click="submitForm" size="small" class="sure-button">
          {{$t('deliveryGoods.saveAndPrint')}}
        </el-button>
        <el-button @click="tpProdAction" size="small" type="primary">
          确认发货
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { prodOrderDetailById } from '@/api/prodOrder';
import { customersList } from '@/api/customers';
import { productsList } from '@/api/products';
import { consignorsList } from '@/api/consignors';
import {
    validateIncomingOrderNo,
    validateLotNo,
    validateCount,
    validateContactPhone,
    validateProductDetails,
  } from '@/utils/validate';
import {
  priorityLevels, processTypes, storeStatus, expressages, expressageTypes,labelTypes,
} from '@/utils/defines';
import { isValueEmpty, isPositiveIntegerNum } from '@/utils';
import exportTpInvoiceXlsx from '@/utils/exportTpInvoice';
import { tporderPut, tporderDetail,caseDetailByProductOrderNo,sendPut } from '@/api/tpProdOrder';
import {
  boxLabelTypes,
} from '@/utils/defines';

const defaultProductDetail = {
    prodInfo: undefined,
    count: undefined,
  };

const defaultForm = {
  processingOrderNo: undefined,
  purchaseOrderNo: undefined,
  customPartNo: undefined,
  productOrderNo: undefined,
  orderDate: undefined,
  customerId: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactAddr: undefined,
  comment: undefined,
  expressageType: undefined,
  expressage: undefined,
  priorityLevel: undefined,
  expectCount: undefined,
  binLevelArr: undefined,
  prodInfos: [{
    ...defaultProductDetail,
  }],
};

const adddefaultForm = {
  boxNumber: 2,
  sBoxNumber: 2,
  trNo: undefined,
};

const FAIL_BIN = 8;

export default {
  name: 'check-info',
  props: [
    'productOrder',
  ],
  data() {
    const processTypesObj = {};
    let processTypeItem;
    for (const key in processTypes) {
      if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
        processTypeItem = processTypes[key];
        processTypesObj[processTypeItem.val] = processTypeItem.explain;
      }
    }
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.prodOderExplain || storeStatueItem.explain;
      }
    };
    let validateNum = (rule, value, callback) => {
        if (isValueEmpty(value)) {
            callback(new Error('不能为空'));
            return;
        }
        if (!isPositiveIntegerNum(value)) {
            callback(new Error('必须为大于等于1小于等于5的正整数'));
            return;
        }
        if (parseFloat(value) < 1 || parseFloat(value) > 5) {
            callback(new Error('必须为大于等于1小于等于5的正整数'));
            return;
        }
        callback();
    };
    let validateTrNo = (rule, value, callback) => {
        if (isValueEmpty(value)) {
            callback();
            return;
        }
        if (!(/^IC56-[0-9][0-9]([0-2][0-9]|3[0-1])-\d{3}$/.test(value))) { // 强力V2标签批号格式如IC56-YYMM-004
          callback(new Error('请输入正确的格式(IC56-YYMM-***)'));
          return;
        }
        callback();
    };
    return {
      form: {...defaultForm, prodInfos : [{ ...defaultProductDetail }]},
      addform: Object.assign({}, adddefaultForm),
      rules: {
        productOrderNo: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.productOrderNoCanNotBeEmpty') }],
        orderDate: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.orderTimeCanNotBeEmpty') }],
        expectCount: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expectedDeliveryNumberCanNotBeEmpty') }],
        customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        contactAddr: [{ required: true, trigger: 'blur', message: '地址不能为空' }],
        expressageType: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageTypeCanNotBeEmpty') }],
        expressage: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageCanNotBeEmpty') }],
        processingOrderNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        purchaseOrderNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        customPartNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        binLevelArr: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.binLevelArrCanNotBeEmpty') }],
      },
      addrules: {
        boxNumber:  [{ required: true, trigger: 'blur', validator: validateNum}],
        sBoxNumber:  [{ required: true, trigger: 'blur', validator: validateNum}],
        trNo:  [{ required: false, trigger: 'blur', validator: validateTrNo}],
      },
      customersList: [],
      productsList: [],
      productsListObj: {},
      processTypesObj,
      storeStatusObj,
      expressages,
      expressageTypes,
      labelTypes,
      prodStores: [],
      detail: {},
      detailProdStores: [],
      dialogVisible: false,
      loadingForm: false,
      incoOrderProdStoreParsed: [],
      labelType: 0,
    };
  },
  mounted() {
    this.customersListGet(1, 200);
    this.productsListGet(1, 200);
    this.tporderDetail();
  },
  methods: {
    async tpProdAction(){
      const {
        productOrderNo,
      } = this.productOrder;
      try {
        const res = await sendPut({ productOrderNo });
        this.$message({
          type: 'success',
          message: '确认成功',
        });
        this.$emit('nexStep');
      } catch (e) {
        // do nothing.
      } finally {
      }
    },
    orderNoVal(row) {
      const {
        incoOrderNo
      } = row;
      return `${incoOrderNo}`;
    },
    productNameVal(row) {
      const {
        productName,
        chipName,
      } = row;
      if (!productName || !chipName) {
        return '';
      }
      return `${productName} / ${chipName}`;
    },
    processTypeVal(row) {
      const {
        processType
      } = row;
      return this.processTypesObj[processType];
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    expressageVal(val) {
      return this.expressagesObj[`${val}`];
    },
    expressageTypeVal(val) {
      return this.expressageTypesObj[`${val}`];
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm:ss');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm:ss');
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 3 || columnIndex === 7) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
	  addClick() {
	   this.addProductDetails();
	  },
	  isEmptyProductDetails() {
	    const {
	      prodInfos,
	    } = this.form;
	    if (prodInfos && prodInfos.length === 0) {
	      this.$message({
	        type: 'error',
	        message: this.$t('validate.productDetailsCanNotBeEmpty'),
	      });
	      return false;
	    }
	    let prodInfo, count,isDataEmpty, isEmptyProductDetails = true;
	    for (let row of prodInfos) {
	      prodInfo = row.prodInfo;
	      count = row.count;
	      isDataEmpty = isValueEmpty(prodInfo) && isValueEmpty(lotNo);
	      if (!isDataEmpty) {
	        isEmptyProductDetails = false;
	         break;
	      }
	    }
	    if (isEmptyProductDetails) {
	      this.$message({
	        type: 'error',
	        message: this.$t('validate.productDetailsCanNotBeEmpty'),
	      });
	      return false;
	    }
	    return true;
	  },
	  addProductDetails() {
	    this.form.prodInfos.push({...defaultProductDetail});
	  },
	  addDetail() {
	    this.form.prodInfos.push({...defaultProductDetail});
	  },
	  deleteProductDetails(index) {
	    this.form.prodInfos.splice(index, 1);
	  },
	  checkCount(rule, value, callback, index) {
	    if (this.isAllDataEmpty(index)) {
	      callback();
	      return true;
	    }
	    return validateCount(rule, value, callback);
	  },
	  checkProductId(rule, value, callback, index) {
	    if (this.isAllDataEmpty(index)) {
	      callback();
	      return true;
	    }
	    if (isValueEmpty(value)) {
	      callback(new Error(this.$t('validate.productNameCanNotBeEmpty')));
	      return false;
	    }
	    callback();
	    return true;
	  },
	  isAllDataEmpty(index) {
	    const {
	      prodInfo,
	      count,
	    } = this.form.prodInfos[index];
	    return isValueEmpty(prodInfo) && isValueEmpty(count);
	  },
	  async productsListGet(page, perpage) {
	    try {
	      const res = await productsList({ page, perpage });
	      const { data } = res;
	      this.productsList = data.records;
	      this.productsListObj = {};
	      for (let row of this.productsList) {
	        this.productsListObj[row.id] = row.productName + ' / ' + row.chipName
	      }
	    } catch (e) {
	      // do nothing.
	    }
	  },
    prevStep() {
      this.$emit('prevStep');
    },
    exportProdStores() {
      const detailProdStores = this.detailProdStores;
      let prodStores = [];
      let length, info, count, badChipInfoCount, directrix = 0, prodStoresItemArray;
      for (const row of detailProdStores) {
        info = row.info;
        count = row.count;
        length = info.length;
        badChipInfoCount = 0;
        prodStoresItemArray = [];
        for (let i = 0; i < length; i++) {
          if (row.binLevel === FAIL_BIN) {
            for (let [key, val] of Object.entries(info[i].badChipInfo)) {
              if (badChipInfoCount === 0) {
                prodStoresItemArray.push({
                  ...row,
                  ...info[i],
                  binLevelVal: key,
                  count: val,
                  rowspan: Object.keys(info[i].badChipInfo).length,
                  allCount: count,
                });
              } else {
                prodStoresItemArray.push({
                  ...row,
                  ...info[i],
                  binLevelVal: key,
                  count: val,
                  rowspan: length,
                  allCount: count,
                });
              }
              badChipInfoCount++;
            }
          } else {
            if (i === 0) {
              prodStoresItemArray.push({
                ...row,
                ...info[i],
                binLevelVal: 'A',
                rowspan: length,
                allCount: count,
              });
            } else {
              prodStoresItemArray.push({
                ...row,
                ...info[i],
                binLevelVal: 'A',
                rowspan: length,
                allCount: count,
              });
            }
          }
        }
        prodStoresItemArray.sort((a, b) => b.count - a.count);
        for (let i = 1, arrayLength = prodStoresItemArray.length; i < arrayLength; i++) {
          prodStoresItemArray[i].rowspan = undefined;
        }
        prodStores = prodStores.concat(prodStoresItemArray);
        if (row.binLevel === FAIL_BIN) {
          prodStores[directrix].rowspan = badChipInfoCount === 1 ? undefined : badChipInfoCount;
          directrix = badChipInfoCount;
        } else {
          directrix = length;
        }
      }
      return prodStores;
    },
    factoryLabel() {
      this.dialogVisible = true;
      this.addform = Object.assign({}, adddefaultForm);
    },
    saveForm(){
      this.$refs.refaddForm.validate(async (valid) => {
        if (valid) {
          this.dialogVisible = false;
          this.loadingForm = true;
          this.getLabel();
        }
      });
    },
    async getLabel() {
      const {
        productOrderNo,
      } = this.productOrder;
      const {
        processingOrderNo,
        purchaseOrderNo,
        customPartNo,
      } = this.form;
      const {
        boxNumber,
        sBoxNumber,
        trNo,
      } = this.addform;
      const tempPage = window.open('', '_blank');
      try {
        const res = await caseDetailByProductOrderNo({ productOrderNo });
        let blabels = [];
        let list = res.data;
        let dateCode = moment().format('YYYY-MM-DD');
        let boxlabel;
        let hasBoxLabel = false;
        for(let type of this.labelTypes){
          if(type.val === this.labelType){
            hasBoxLabel = type.hasBoxLabel;
            break;
          }
        }
        for(let temp of list) {
          boxlabel = {};
          boxlabel.labelType = this.labelType;
          boxlabel.boxLabelType = boxLabelTypes.boxLabel.val;
          boxlabel.processingOrderNo = processingOrderNo;
          boxlabel.purchaseOrderNo = purchaseOrderNo;
          boxlabel.customPartNo = customPartNo;
          boxlabel.qty = temp.qty;
          boxlabel.dateCode = dateCode;
          boxlabel.partNo = temp.partNo;
          boxlabel.lotNo = temp.lotNo;
          boxlabel.marking = temp.marking;
          boxlabel.netWeight = temp.netWeight || undefined;
          boxlabel.packageType = temp.packageType;
          boxlabel.productName = temp.labels[0].product.productName;
          boxlabel.chipName = temp.labels[0].product.chipName;
          boxlabel.binLevel = temp.binLevel;
          boxlabel.reserve = temp.reserve;
          if(this.labelType === 3 || this.labelType === 12){
            boxlabel.trackingNo = trNo;
          }else{
            boxlabel.trackingNo = temp.trackingNo;
          }
          boxlabel.grossWeight =  temp.grossWeight || undefined;
          boxlabel.printCount = boxNumber;

          let detail = [];
          if(hasBoxLabel){
            let d;
            for(let prodStoreDetails of temp.labels) {
              d = {};
              d.qty = prodStoreDetails.qty;
              if(this.labelType === 3 || this.labelType === 12){
                d.trackingNo = trNo;
              }else{
                d.trackingNo = prodStoreDetails.trackingNo;
              }
              detail.push(d);
              d.printCount = sBoxNumber;
            }
          }
          boxlabel.detail = detail;
          blabels.push(boxlabel);
        }

        if(this.labelType === 3 || this.labelType === 12){
          let bList = this.getAddLabelData(list,boxNumber);
          blabels.push.apply(blabels,bList);
        }
        const { href } = this.$router.resolve({
          path: `/factory-label-print`,
          query: {
            data: encodeURIComponent(JSON.stringify(blabels))
          },
        });
        tempPage.location = href;
      } catch (e) {
        // do nothing.
      } finally {
        this.loadingForm = false;

      }
    },
    getAddLabelData(list,printCount){
      const {
        productOrderNo,
      } = this.productOrder;
      const {
        processingOrderNo,
        purchaseOrderNo,
        customPartNo,
      } = this.form;
      const {
        boxNumber,
        sBoxNumber,
        trNo,
      } = this.addform;
      let dateCode = moment().format('YYYY-MM-DD');
      let blabels = [];
      let boxlabel;
      for(let temp of list) {
        boxlabel = {};
        boxlabel.labelType = 14;
        boxlabel.boxLabelType = boxLabelTypes.boxLabel.val;
        boxlabel.processingOrderNo = processingOrderNo;
        boxlabel.purchaseOrderNo = purchaseOrderNo;
        boxlabel.customPartNo = customPartNo;
        boxlabel.qty = temp.qty;
        boxlabel.dateCode = dateCode;
        boxlabel.partNo = temp.partNo;
        boxlabel.lotNo = temp.lotNo;
        boxlabel.marking = temp.marking;
        boxlabel.netWeight = temp.netWeight || undefined;
        boxlabel.packageType = temp.packageType;
        boxlabel.productName = temp.labels[0].product.productName;
        boxlabel.chipName = temp.labels[0].product.chipName;
        boxlabel.binLevel = temp.binLevel;

        boxlabel.trackingNo = trNo || undefined;

        boxlabel.grossWeight =  temp.grossWeight || undefined;
        boxlabel.printCount = printCount;
        let infoObj = {};
        let info = [];
        boxlabel.customPartNo = temp.trackingNo;
        for(let prodStores of this.detailProdStores){
          if(temp.trackingNo === prodStores.boxNo){
            for(let pinfo of prodStores.info){
              let obj = {};
              obj.lotNo = pinfo.lotNo;
              obj.cnt = pinfo.count;
              info.push(obj);
            }
          }
        }
        if(info.length === 1){
          continue;
        }
        infoObj.info = info;
        boxlabel.reserve = JSON.stringify(infoObj);
        blabels.push(boxlabel);
      }
      return blabels;
    },
    dialogClosed () {
        this.$refs.refaddForm && this.$refs.refaddForm.resetFields();
    },
    async exportXlsx() {
      const productOrderNo = this.form.productOrderNo;
      const prodStores = this.exportProdStores();
      try {
        const resConsignors = await consignorsList({
          perpage: 10,
          page: 1,
        });
        const consignorsData = resConsignors.data;
        let consignor = {};
        if (consignorsData && consignorsData.records && consignorsData.records.length > 0) {
          consignor = consignorsData.records[0];
        }
        const {
          contactAddr,
          expressage,
        } = this.form;
        const expressages = this.expressages;
        exportTpInvoiceXlsx({
          consignor,
          prodStores,
          productOrderNo,
          contactAddr,
          expressage: expressages[expressage].explain,
        });
      } catch (e) {
        // do nothing.
      }
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.onSave();
        }
      });
    },
    async onSave() {
      const {
        prodStores
      } = this;
      const {
        expectCount
      } = this.form;
      if (!prodStores || prodStores && prodStores.length === 0) {
        this.$message({
          type: 'error',
          message: '请先去手持设备上关联箱子',
        });
        return;
      }
      let count = 0;
      for (let row of prodStores) {
        count += row.count;
      }
      if (count < expectCount) {
        this.$confirm(this.$t('deliveryGoods.chipCountLessThanExpectCount'), this.$t('remindInfo.warning'), {
          confirmButtonText: this.$t('remindInfo.confirm'),
          cancelButtonText: this.$t('remindInfo.cancel'),
          type: 'warning',
        }).then(async () => {
          this.toInvoice();
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.toInvoice();
      }
    },
    toInvoice() {
      const {
        productOrderNo,
      } = this.productOrder;
      const { href } = this.$router.resolve({
        path: `/tpinvoice/${productOrderNo}`,
        query: {},
      });
      window.open(href, '_blank');
    },
    changeCustomer(val) {
      const {
        contact,
        contactPhone,
        contactAddr,
      } = this.form;
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.contact = row.contact;
            this.form.contactPhone = row.contactPhone;
            this.form.contactAddr = row.contactAddr;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
            break;
          }
        }
      }
    },
    async customersListGet(page, perpage, customerName) {
      try {
        const res = await customersList({ page, perpage, customerName });
        const { data } = res;
        this.customersList = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    async tporderDetail() {
      const {
        productOrderNo,
      } = this.productOrder;
      try {
        const res = await tporderDetail({ productOrderNo });
        const {
          data,
        } = res;
        if (data) {
          const {
            productOrderNo,
            createAt,
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment,
            expressageType,
            expressage,
            priorityLevel,
            prodStores,
            expectCount,
            binLevelData,
            prodInfos,
            processingOrderNo,
            purchaseOrderNo,
            customPartNo,
          } = data.detail;
          this.detailProdStores = prodStores;
          this.prodStores = [];
          let length, info, count, index = 0;
          for (let row of prodStores) {
            info = row.info;
            count = row.count;
            length = info.length;
            index++;
            for(let i = 0; i < length; i++) {
              if (i === 0) {
                this.prodStores.push({
                  ...row,
                  ...info[i],
                  rowspan: length,
                  allCount: count,
                  index,
                });
              } else {
                this.prodStores.push({
                  ...row,
                  ...info[i],
                  allCount: count,
                });
              }
            }
          }
          this.labelType = data.detail.customer.labelType;
          this.incoOrderProdStoreParsed = data.incoOrderProdStoreParsed;
          this.form = {
            productOrderNo,
            orderDate: this.formatDate(createAt),
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment,
            expressageType,
            expressage,
            priorityLevel,
            expectCount,
            processingOrderNo,
            purchaseOrderNo,
            customPartNo,
            prodInfos:JSON.parse(prodInfos),
          };

        }
      } catch (e) {
        // do nothing.
      }
    },
    productName(row) {
      const {
        productName,
        chipName,
      } = row;
      if (!productName || !chipName) {
        return '';
      }
      return `${productName} / ${chipName}`;
    },
  },
};
</script>
<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .topContainer {
    height: 100%;
    overflow: auto;
    flex: 1;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    background: #F5F5F5;
    padding: 20px;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .target-container {
    margin: 20px 20px 0;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .prev-button {
    background: white;
    color: #EC7900;
    border: #EC7900 solid 1px;
  }
  .sure-button {
    background: #EC7900;
    color: white;
  }
  .el-form {
    padding: 10px 20px 0;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
